export const QUARTILE_FIELDS = [
  'MaleTopQuartile',
  'FemaleTopQuartile',
  'MaleUpperMiddleQuartile',
  'FemaleUpperMiddleQuartile',
  'MaleLowerMiddleQuartile',
  'FemaleLowerMiddleQuartile',
  'MaleLowerQuartile',
  'FemaleLowerQuartile'
] as const;

export const hasQuartileDataForYear = (company: any, year: number) => (
  QUARTILE_FIELDS.some((field) => company[`${year}_${field}`] !== null && company[`${year}_${field}`] !== undefined)
);
